<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429984003_toc01#toctitle2" id="title2"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>Our big thanks to agent Jacqueline Hackett, editor Eric Raab, publisher Tom Doherty, and the man himself, Walter Mosley, for their roles in making <em class="i">The Darker Mask</em> happen.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429984003_ack01.vue?47cc2a19